export const MAPIA_WHATSAPP = "21993751975";

export const waLink = (phone, text) => {
  let n = String(phone || "").replace(/\D/g, "");
  if (!n) return null;
  if (n.length <= 11) n = `55${n}`;
  return `https://wa.me/${n}?text=${encodeURIComponent(text)}`;
};
